import { render, staticRenderFns } from "./otherIndex.vue?vue&type=template&id=108aa64d&scoped=true&"
import script from "./otherIndex.vue?vue&type=script&lang=js&"
export * from "./otherIndex.vue?vue&type=script&lang=js&"
import style0 from "./otherIndex.vue?vue&type=style&index=0&id=108aa64d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108aa64d",
  null
  
)

export default component.exports